import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UserContext} from '../services/user-context';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ApiService} from '../services/api';
import {LoadingIndicatorService} from '../shared/layout/components/loading-indicator';

@Component({
  selector: 'app-bank-account',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'bank-account.template.html',
  styles: [
    "app-bank-account mat-dialog-container {padding:0;}",
    "app-bank-account mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;border-top:1px solid rgb(227, 232, 238); box-shadow:rgb(227, 232, 238) 0px -1px 0px 0px inset;}",
    "app-bank-account mat-dialog-actions {display:flex;flex-direction: row;justify-content: flex-end;padding:0;}",
    "app-bank-account mat-dialog-actions .k-button {height:auto;margin-left:10px;}",
    "app-bank-account .digits {letter-spacing: 2px}",
    "app-bank-account .k-grid .grid-column-header {background:#f1f4f6;font-weight:400!important;}",
    "app-bank-account .k-grid tr.k-alt { background-color: #fcfcfc; }"

  ]
})

export class BankAccountComponent implements OnInit {
  public form: FormGroup;

  countries = ['US', 'CA'];
  external_accounts:any[] = [];
  routing_title:string;
  options:any;
  entity:any;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<BankAccountComponent>,
              private snackBar: MatSnackBar,
              public loadingService: LoadingIndicatorService,
              private api: ApiService,
              private userContext: UserContext,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.options = Object.assign({mode:'user'},this.data);
    if( this.options.mode === 'user' ) {
      this.entity = {path:'user', id:this.userContext.user.reference};
    } else {
      this.entity = {path:'account', id:this.userContext.account.id}
    }
  }

  public ngOnInit(): void {
    let country = '';
    if( this.options.mode === 'user' ) {
      country = (this.userContext.user.country || this.userContext.account.country || "").toLowerCase();
    } else {
      country = (this.userContext.account.country || "").toLowerCase();
    }
    if( country.includes('ca') ) {
      this.routing_title = "Transit-Institution"
    } else {
      this.routing_title = "Routing Number"
    }
    this.buildForm();

    this.refresh();
  }

  private refresh() {
    this.api.get<any>(`/${this.entity.path}/${this.entity.id}/external-account`)
      .subscribe(result => {
        this.external_accounts = result.data || [];
      });
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      routing_number: new FormControl( '', [
        Validators.required,
        Validators.minLength(8)
      ]),
      account_number: new FormControl('', [
        Validators.required,
        Validators.minLength(6)
      ])
    });
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public add() {
    this.api.post<any>(`/${this.entity.path}/${this.entity.id}/external-account`, this.form.value)
      .subscribe(result => {
        this.form.reset();
        this.refresh();
      });
    this.snackBar.open('Bank account added successfully', null, {
      duration: 2000
    });
  }

  public remove( external_account:any) {
    this.api.del(`/${this.entity.path}/${this.entity.id}/external-account/${external_account.id}`)
      .subscribe(result => {
        this.refresh();
      });
    this.snackBar.open('Bank account removed', null, {
      duration: 2000
    });
  }

  public makeDefault( external_account:any) {
    this.api.patch<any>(`/${this.entity.path}/${this.entity.id}/external-account/${external_account.id}`, {default_for_currency:true})
      .subscribe(result => {
        this.refresh();
      });
    this.snackBar.open('Bank account updated', null, {
      duration: 2000
    });
  }

  public cancel() {
    this.dialogRef.close();
  }
}
